module.exports = __webpack_public_path__ + "img/img-panel-multimarca.f84a5d72.webp";